import * as React from 'react'
import {Navigate} from 'react-router'
import {useSafeEffect} from '@freckle/react-hooks'

import {checkConnectionAjax} from '@frontrow/console/src/helpers/auth-helpers'
// Components
import LoginPage from '@frontrow/console/src/components/pages/login-page/login-page'

export default function LoginPageContainer(): React.ReactElement {
  const [isAlreadyLogged, setIsAlreadyLogged] = React.useState<boolean>(false)

  useSafeEffect(() => {
    checkConnectionAjax().then(isAlreadyLogged => {
      setIsAlreadyLogged(isAlreadyLogged)
    })
  }, [])

  return isAlreadyLogged ? <Navigate to={'/'} replace /> : <LoginPage />
}
